import ContentErrors from "@/react/story/components/ContentErrors";
import contentToInfos from "@/react/story/fns/content-to-infos";
import { useErrors } from "@/react/story/providers/ErrorsContext";
import { useLocales } from "@/react/story/providers/LocalesContext";
import { type Content, type ContentInfos, ContentTypeEnum } from "@/react/story/types";
import { useEffect, useState } from "react";

type Props = {
    content: Content;
    viewContent: (content: Content) => void;
}

export default function ContentText(props: Props) {
    const Locales = useLocales();
    const Errors = useErrors();

    const [ infos, setInfos ] = useState<ContentInfos | null>(null);

    useEffect(() => {
        setInfos(contentToInfos(props.content, Locales.current));
    }, [ props.content, Locales.current ]);

    if (!infos) {
        return null;
    }

    let text: string | undefined = (infos.text ?? "").trim();
    if ("" === text) {
        text = undefined;
    }
    if (ContentTypeEnum.LOCALE_PICKER === props.content.type) {
        text ??= "Sélecteur de langue";
    }
    if (ContentTypeEnum.VIDEO === props.content.type) {
        text ??= props.content.config.video?.clientFilename ?? "Vidéo";
    }

    return (
        <div className="input-group">
            <div className="input-group-text">
                <span className={`bi-${infos.icon}`}></span>
            </div>
            <div className="form-control bg-light d-flex justify-content-between align-items-center gap-3">
                <span style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{text ?? ""}</span>
                <ContentErrors errors={Errors.inContent(props.content)} />
            </div>
            <button className="btn btn-secondary" type="button" onClick={() => props.viewContent(props.content)}>
                <span className="bi-gear"></span>
            </button>
        </div>
    );
}
